import { Stack, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

function NotFoundPage() {
  return (
    <Stack alignItems="center">
      <Typography variant="h1" sx={{ py: 2, textAlign: "center" }}>
        Không tìm thấy trang
      </Typography>
      <Link to="/">Vê trang chủ</Link>
    </Stack>
  );
}

export default NotFoundPage;
